<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deleteRegion" @cancel="cancel" />
    <v-data-table
      :headers="headers"
      :items="riskFactors"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Risk Factor</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.mm_name }}</td>
          <td>
            <div>
              <v-btn
                @click="goUpdateForm(item)"
                icon
                color="orange darken-1"
                class="mr-2 white--text"
                depressed
              >
                <v-icon> mdi-pencil-outline </v-icon>
              </v-btn>
              <v-btn
                @click="openConfrimBox(item)"
                icon
                color="red lighten-1"
                class="white--text"
                depressed
              >
                <v-icon> mdi-delete-outline </v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ConfirmBox from "@/components/notification/ConfirmBox";

export default {
  props: {
    riskFactors: {
      type: Array,
    },
  },
  components: {
    ConfirmBox,
  },
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    dialog: false,
    headers: [
      { text: "No", value: "no" },
      { text: "Name", value: "name" },
      { text: "Myanmar Name", value: "mm_name" },
      { text: "Actions", value: "actions", align: "end" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deleteRegion() {
      let data = {
        id: this.item.id,
      };
      this.$store
        .dispatch("RiskFactor/deleteRiskFactor", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    goUpdateForm(item) {
      this.$router.push({
        name: "edit-risk-factor",
        params: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
